import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/tradingvalley-frontend/growin/apps/web/features/robo-advisor/components/Program.tsx");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/public/footer/android.png");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/public/footer/ios.png");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/public/robo/bg-grass-mobile.png");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/public/robo/bg-grass.png");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/public/robo/product-banner-en.webp");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/public/robo/product-banner-zh.webp");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/node_modules/next/dist/client/link.js");
